import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import success from '../../assets/images/success.png';
import fail from '../../assets/images/fail.png';
import './StatusPage.scss';



const StatusPage = () => {
  const { state } = useLocation();
  const location = useLocation();
  const [message, setMessage] = useState("");
  const handleRedirect = () => {
    console.log("Redirecting to the home page...");
  };
  useEffect(() => {
    if (location.search) {
      const mes = new URLSearchParams(location.search).get("message");
      if (mes) {
        setMessage(mes);
      }
    }
    if (state?.message) {
      setMessage(state?.message);
    }
  }, []);

  return (
      <Container
      fluid
      className="pt-10 vh-100 bg-light"
    >
      <Row className="status-page text-center">
        <Col>
          {location.pathname.includes("success") ? (
            // <BsCheckCircle style={{ fontSize: "5rem", color: "green" }} />
           <img src={success} className="mb-3" alt="" />
          ) : (
            // <BsXCircle style={{ fontSize: "5rem", color: "red" }} />
            <img src={fail} className="mb-3" alt="" />
          )}
          <h2 className="mt-4">
            {location.pathname.includes("success") ? "Success!" : "OOPS!"}
          </h2>
          <p className="text-muted mb-4">
            {message
              ? message
              : location.pathname.includes("success")
              ? "Your operation was completed successfully."
              : "Something went wrong"}
          </p>
          {/* <Button className="btn btn-primary"> Go to Home  </Button> */}
        </Col>
      </Row>
    </Container>
  );
};

export default StatusPage;
